import {Card, CardActionArea, CardMedia, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {downloadImage} from "../../helpers/utils";
import {useEffect, useMemo, useState} from "react";

import {parseValue} from "../../hooks";

import {useFetch} from "../../helpers/hooks";
import {Endpoint} from "../../constants/enums";

import {LinkOutlined, PlaceOutlined} from "@material-ui/icons";
import {Link} from "react-router-dom";

const useStyles = makeStyles({
  root: {
    width: '100%',
    minHeight: 500,
    height: 'auto'
  },
  media: {
    height: 320,
    backgroundPosition: 'top'
  },
});

const ExtraInformationItem = ({text, icon, href}) => {
  const InfoIcon = icon

  return <>
    {text && text !== '' &&
      <>
        <Grid item xs={2}>
          <InfoIcon/>
        </Grid>
        <Grid item xs={10}>
          {href ? <a href={href} rel={'noreferrer'} target={'_blank'}>
              <Typography variant={'caption'}>{text}</Typography>
            </a>
            : <Typography variant={'caption'}>{text}</Typography>
          }
        </Grid>
      </>
    }
  </>
}

const ExtraInformation = ({place, source}) => {
  return <Grid container spacing={2} style={{marginTop: 80}} direction={'row'} alignItems={'center'}
               alignContent={'center'}>
    <ExtraInformationItem text={place} icon={PlaceOutlined} key={1}/>
    <ExtraInformationItem text={source} icon={LinkOutlined} href={source} key={2}/>
  </Grid>
}

const CompositionCard = (props) => {

  const classes = useStyles();

  const {data} = props
  const url = `${Endpoint.containers}/${data.uuid}`
  const [, result, ] = useFetch(url);
  const [thumbnail, setThumbnail] = useState(null)
  const [coverImage,setCoverImage] = useState(thumbnail)

  useEffect(()=>{
    if (thumbnail)
      setCoverImage(thumbnail)
  },[thumbnail])




  const description = useMemo(() => {
    if (!result) return
    return parseValue('property:description', result?.properties)
  }, [result])

  const place = useMemo(() => {
    if (!result) return
    return parseValue('property:place', result?.properties)
  }, [result])

  const source = useMemo(() => {
    if (!result) return
    return parseValue('property:url', result?.properties)
  }, [result])

  const evretirioUuid = useMemo(()=>{
    if (!result) return null
    return  result?.uuid
  },[result])


  useMemo(() => {
    const imageDataStreams = result?.datastreams?.filter((d)=>d.type.code === 'image-composition')
    if (imageDataStreams?.length >0)
    downloadImage(imageDataStreams[0]?.uuid, setThumbnail)
  }, [result])

  return <Card className={classes.root} component={Link} to ={`/evretirio/${evretirioUuid}`}>
    <CardActionArea>
      <CardMedia
        className={classes.media}
        image={coverImage}
        title={result?.label}
      />
    </CardActionArea>
    <CardContent>
      <Grid container direction={'column'}>
        <Grid item>
          <Typography gutterBottom variant="h6" component="h6" align={'center'}>
            {result?.label}
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={'body2'} align={'center'}>
            {description}
          </Typography>
        </Grid>
        <Grid item>
          <ExtraInformation place={place} source={source}/>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}

export default CompositionCard